import { Component, inject, input } from '@angular/core';

import { StorefrontPage } from '../../model/storefront-page';
import { SeoService } from '../../service/seo.service';
import { WebsiteService } from '../../service/website.service';

@Component({
  selector: 'about-page',
  host: {
    style: 'display: contents'
  },
  template: `
    <!-- Title Page -->
    <section class="bg-title-page p-t-15 p-b-16 flex-col-c-m">
      <h1 class="l-text2 t-center">
        Про нас
      </h1>
    </section>

    <!-- content page -->
    <section class="bgwhite p-t-66 p-b-38">
      <div class="container">
        <div class="row">
          <div class="col-md-4 p-b-30">
            <div class="hov-img-zoom">
              <img [src]="website().about?.photo" [alt]="website().name">
            </div>
          </div>

          <div class="col-md-8 p-b-30">
            <h3 class="m-text26 p-t-15 p-b-16">
              {{website().about?.title}}
            </h3>

            @for (paragraph of website().about?.paragraphs; track $index) {
              <p class="p-b-28" [innerHTML]="paragraph"></p>
            }
          </div>
        </div>
      </div>
    </section>
    `
})
export class AboutPageComponent {

  readonly data = input.required<StorefrontPage>();
  readonly website = inject(WebsiteService).current;

  constructor() {
    inject(SeoService).page(this.data, true);
  }

}
